<template>
  <div class="page-autumn-course">
    <img class="head-img"
         :src="banner"
         alt="封面图"
         v-if="banner !== ''"
    />
    <div class="info-block">
      <div class="count-down-block">
        <img class="leaf"
             :src="require('@/pages/2019/AutumnCourse/assets/img/leaf.png')"
             alt=""
        />
        <count-down class="count-down"
                    :start="countDown.startTime"
                    :end="countDown.endTime"
                    :blockBgImg="getBlockBgImg"
                    :itemBgImg="getItemBgImg"
                    @count-down-ended="handleCountDownEnded"
                    v-if="countDown"
        />
        <div class="group-buy"
             v-else-if="qrCode"
        >
          <img class="code"
               :src="qrCode.src"
               alt="二维码"
          />
        </div>
      </div>
      <div class="content">
        <div class="text">
          <div class="first-text">
            <div>拓展孩子知识视野的广度和思维创新的深度</div>
            <div>不仅是通识教育和世界名校的共识</div>
            <div class="orange">也是近几年来，中高考改革频频发出的信号</div>
          </div>
          <div class="second-text">
            <div>
              为孩子找到
              <span class="orange">最适合的第二课堂</span>
            </div>
            <div>无论对其兴趣发展</div>
            <div>
              还是小升初与中考
              <span class="orange">“弯道超车”</span>
            </div>
            <div>抑或留学背景提升</div>
            <div>都非常重要</div>
            <div>并且任何时候开始都不算早</div>
          </div>
        </div>
      </div>
    </div>
    <div class="arcBg"></div>
    <div class="course">
      <div class="survey">
        <img class="survey-head"
             :src="require('@/pages/2019/AutumnCourse/assets/img/survey.png')"
             alt=""
        />
        <div class="survey-item"
             v-for="(item, index) in survey"
             :key="index">
          <img class="survey-img"
               :src="item.img"
               alt=""
          />
          <div class="survey-text">{{ item.text }}</div>
        </div>
      </div>
      <div class="specialities">
        <img class="specialities-head"
             :src="require('@/pages/2019/AutumnCourse/assets/img/specialities.png')"
             alt=""
        />
        <div class="specialities-block">
          <div class="specialities-item"
             v-for="(item, index) in specialities"
             :key="index">
          <img class="specialities-img"
               :src="item.img"
               alt=""
          >
          <div class="specialities-content">
            <div class="specialities-title">{{ item.title }}</div>
            <div class="specialities-text">{{ item.describe }}</div>
          </div>
        </div>
        </div>
      </div>
      <div class="live-course">
        <img class="course-head"
             :src="require('@/pages/2019/AutumnCourse/assets/img/liveCourse.png')"
             alt=""
        />
        <div class="course-block">
          <div class="course-title">
            <span>点击</span>
            <span class="red">任一主题</span>
            <span>可查看11月视频直播课详情</span>
          </div>
          <div class="form-title">
            <div class="college">学院</div>
            <div class="course-series">课程主题</div>
            <div class="age">适合年龄</div>
          </div>
          <div class="college-item"
               v-for="(item, index) in schedules"
               :key="index"
          >
            <div class="college-name">{{ item.collegeName }}</div>
            <div class="product-list">
              <div class="product-item"
                   v-for="(productItem, productIndex) in item.courseList"
                   :key="productIndex"
              >
                <div class="item-title">
                  <a :href="productItem.productPath"
                     target="_blank"
                     v-html="productItem.title"></a>
                </div>
                <div class="item-age">{{ productItem.age }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="harvest">
        <img class="harvest-head"
             :src="require('@/pages/2019/AutumnCourse/assets/img/harvest.png')"
             alt=""
        />
        <div class="harvest-block">
          <div class="harvest-item"
               v-for="(item, index) in harvest"
               :key="index"
          >
            <div class="harvest-title">{{ item.title }}</div>
            <div class="harvest-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <member-review-video :poster="video.src"
                         :src="video.url"
                         :status="render.status"
                         v-if="video"
    />
    <product-list :list="products"
                  :status="render.status"
                  v-if="products.length > 0"
    />
    <div class="count-down-block second">
      <img class="leaf"
           :src="require('@/pages/2019/AutumnCourse/assets/img/leaf.png')"
           alt=""
      />
      <div class="group-buy"
           v-if="qrCode"
      >
        <img class="code"
             :src="qrCode.src"
             alt="二维码"
        />
      </div>
    </div>
    <question-list :replay-url="faq.url"
                   :status="render.status"
                   v-if="faq"
    />
    <div class="contact-us"
         v-if="inH5Platform"
    >
      <div class="tel">
        <a class="external" href="tel:4008093885">电话咨询</a>
      </div>
    </div>
  </div>
</template>

<script>
  import CountDown from '@/components/CountDown';
  import getNovemberCourseInfo from '@/services/november-course';
  import MemberReviewVideo from '@/pages/2019/NovemberCourse/components/MemberReviewVideo';
  import ProductList from '@/pages/2019/AutumnCourse/components/ProductList';
  import QuestionList from '@/pages/2019/AutumnCourse/components/QuestionList';
  import { isWeiXinBrowser, isPC } from '@/utils';

  export default {
    name: 'AutumnCourse',
    components: {
      CountDown,
      MemberReviewVideo,
      ProductList,
      QuestionList,
    },
    data() {
      return {
        /* eslint-disable global-require */
        survey: [
          {
            text: '四大学院,七大主题',
            img: require('@/pages/2019/AutumnCourse/assets/img/firstSurvey.png'),
          },
          {
            text: '7门精品视频直播课',
            img: require('@/pages/2019/AutumnCourse/assets/img/secondSurvey.png'),
          },
          {
            text: '导师皆毕业于斯坦福等世界名校',
            img: require('@/pages/2019/AutumnCourse/assets/img/thirdSurvey.png'),
          },
          {
            text: '包含精美主题工具包与学习证书',
            img: require('@/pages/2019/AutumnCourse/assets/img/fourthSurvey.png'),
          },
        ],
        specialities: [
          {
            title: '趣味性',
            describe: '哈佛案例教学法活泼生动',
            img: require('@/pages/2019/AutumnCourse/assets/img/firstSpecialities.png'),
          },
          {
            title: '双师制',
            describe: '课中课后班主任个性化答疑',
            img: require('@/pages/2019/AutumnCourse/assets/img/secondSpecialities.png'),
          },
          {
            title: '混合制',
            describe: '直播后自主完成创意实践挑战',
            img: require('@/pages/2019/AutumnCourse/assets/img/thirdSpecialities.png'),
          },
          {
            title: '自驱力',
            describe: '激发多学科兴趣与自主学习力',
            img: require('@/pages/2019/AutumnCourse/assets/img/fourthSpecialities.png'),
          },
          {
            title: '游戏化',
            describe: '作品获专业点评与勋章激励',
            img: require('@/pages/2019/AutumnCourse/assets/img/firthSpecialities.png'),
          },
          {
            title: '档案式',
            describe: '建立专属的成长档案',
            img: require('@/pages/2019/AutumnCourse/assets/img/sixthSpecialities.png'),
          },
        ],
        /* eslint-enable global-require */
        schedules: [],
        harvest: [
          {
            title: '1、跨学科学习法与自主学习力',
            content: '视野更开阔，思维更活跃，让孩子爱上学习',
          },
          {
            title: '2、掌握创新思维方法',
            content: '学会从不同角度独立思考问题，解决问题',
          },
          {
            title: '3、提升演讲表达能力与自信心',
            content: '课程与创意实践，锻炼逻辑思维，提升气场',
          },
          {
            title: '4、为升学留学弯道超车提前做准备 ',
            content: '关注趋势变化，提升面向未来的核心竞争力',
          },
        ],
        countDown: null,
        qrCode: null,
        video: null,
        products: [],
        faq: null,
        render: {
          status: '',
        },
        banner: '',
      };
    },
    methods: {
      async fetchData() {
        const data = await getNovemberCourseInfo();
        this.countDown = data.countDown;
        this.qrCode = data.qrCode;
        this.schedules = data.schedules;
        this.video = data.video;
        this.render = data.render;
        this.products = data.products;
        this.faq = data.faq;
        this.banner = `${data.banner}?v=1.1.0`;
      },
      handleCountDownEnded() {
        this.countDown = null;
      },
    },
    computed: {
      /* eslint-disable global-require */
      getBlockBgImg() {
        return require('@/pages/2019/NovemberCourse/assets/img/over_count_down.png');
      },
      getItemBgImg() {
        return require('@/pages/2019/AutumnCourse/assets/img/countDownItem.png');
      },
      /* eslint-enable global-require */
      showQrCode() {
        return isWeiXinBrowser();
      },
      inH5Platform() {
        return !isPC();
      },
      inPC() {
        return isPC();
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .page-autumn-course {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @color-white;
    color: #333;
    background: @color-white;
    padding-bottom: 100px;
    box-sizing: border-box;
  }
  .head-img {
    display: block;
    height: 427px;
    width: 100%;
  }
  .group-buy-head {
    height: 427px;
    width: 100%;
    background: url('~@/pages/2019/AutumnCourse/assets/img/groupBuyHead.png') no-repeat;
    background-size: cover;
  }
  .info-block {
    background: #FCC936;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: 20px;
    .content {
      margin-top: 38px;
      width: 626px;
      border: 5px solid #FC9836;
      background: @color-white;
      box-sizing: border-box;
      .text {
        width: 494px;
        margin: 42px auto 44px;
        text-align: center;
        font-size: 26px;
        line-height: 42px;
        .first-text {
          line-height: 46px;
          font-weight: @font-weight-bold;
        }
        .second-text {
          margin-top: 30px;
        }
        .orange {
          font-weight: @font-weight-bold;
          color: #FF7508;
        }
      }
    }
  }
  .count-down-block {
    margin-top: -40px;
    width: 100%;
    position: relative;
    .leaf {
      width: 100%;
      display: block;
      position: absolute;
      height: 186px;
      z-index: 3;
      top: 0;
      left: 0;
    }
    .count-down {
      margin-top: 10px;
      height: 186px;
    }
    .group-buy {
      height: 228px;
      background: url('~@/pages/2019/AutumnCourse/assets/img/groupBuy.png') no-repeat;
      background-size: cover;
      position: relative;
      .code {
        position: absolute;
        right: 100px;
        top: 130px;
        margin-top: -64px;
        width: 128px;
        height: 128px;
        border-radius: 10px;
      }
    }
    &.second {
      &:before {
        position: absolute;
        width: 100%;
        height: @size-large;
        background: @color-white;
        content: '';
        left: 0;
        top: 0;
        z-index: 2;
      }
      &:after {
        position: absolute;
        width: 100%;
        height: @size-base;
        background: #fef4d7;
        content: '';
        left: 0;
        bottom: -@size-base;
        z-index: 2;
      }
    }
  }
  .arcBg {
    height: 38px;
    width: 100%;
    background: url('~@/pages/2019/AutumnCourse/assets/img/arcBg.png') no-repeat;
    background-size: cover;
  }
  .course {
    margin-top: 34px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .survey {
      width: 590px;
      margin-bottom: 58px;
      .survey-head {
        display: block;
        width: 230px;
        height: 62px;
        margin-bottom: 14px;
      }
      .survey-item {
        width: 590px;
        height: 72px;
        margin-bottom: 6px;
        position: relative;
        .survey-img {
          width: 100%;
          height: 100%;
        }
        .survey-text {
          position: absolute;
          left: 108px;
          top: 20px;
        }
      }
    }
    .specialities {
      width: 664px;
      box-sizing: border-box;
      .specialities-head {
        display: block;
        margin-left: 36px;
        width: 296px;
        height: 70px;
      }
      .specialities-block {
        margin-top: 14px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        width: 100%;
      }
      .specialities-item {
        margin-bottom: 30px;
        height: 300px;
        width: 200px;
        position: relative;
        .specialities-img {
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -50px;
          width: 100px;
          height: 100px;
          z-index: 1;
        }
        .specialities-content {
          position: absolute;
          bottom: 0;
          height: 240px;
          width: 100%;
          border-radius: 20px;
          background: #FCC936;
          display: flex;
          flex-direction: column;
          align-items: center;
          .specialities-title {
            margin-top: 50px;
            font-size: 28px;
            font-weight: @font-weight-bold;
            color: #FF7508;
          }
          .specialities-text {
            margin-top: 30px;
            width: 180px;
            font-size: @font-size-small;
            line-height: 42px;
            text-align: center;
          }
        }
      }
    }
    .live-course {
      width: 664px;
      margin-top: 28px;
      .course-head {
        display: block;
        width: 434px;
        height: 70px;
        margin: 0 0 14px 34px;
      }
      .course-block {
        .course-title {
          padding-left: 10px;
          height: 46px;
          background: #FCC936;
          color: #4D311C;
          line-height: 46px;
          font-size: 26px;
          font-weight: @font-weight-bold;
          .red {
            color: #FF0000;
          }
        }
        .form-title {
          display: flex;
          margin-top: 10px;
          .college {
            padding: 30px 0 30px 0;
            width: 220px;
            border: 1px solid #4d311c;
            border-top-left-radius: 10px;
            border-right: transparent;
            text-align: center;
            color: #FF7508;
          }
          .course-series {
            padding: 30px 0 30px 0;
            width: 300px;
            border: 1px solid #4d311c;
            box-sizing: border-box;
            border-right: transparent;
            text-align: center;
            color: #FF7508;
          }
          .age {
            padding: 30px 0 30px 0;
            width: 134px;
            border: 1px solid #4d311c;
            text-align: center;
            border-top-right-radius: 10px;
            color: #FF7508;
          }
        }
        .college-item{
          display: flex;
          text-align: center;
          &:last-child {
            .college-name {
              border-bottom-left-radius: 10px;
            }
            .product-item {
              &:last-child .item-age {
                border-bottom-right-radius: 10px;
              }
            }
          }
          .college-name {
            width: 220px;
            border: 1px solid #4d311c;
            border-top: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .product-list {
            .product-item {
              display: flex;
              text-align: center;
              .item-title {
                padding: 30px 0 30px 0;
                box-sizing: border-box;
                border-right: 1px solid #4d311c;
                border-bottom: 1px solid #4d311c;
                width: 300px;
                font-weight: @font-weight-heavy;
                a {
                  border-bottom: 1px solid @color-highlight;
                }
              }
              .item-age {
                border-right: 1px solid #4d311c;
                border-bottom: 1px solid #4d311c;
                width: 134px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
    .harvest {
      margin-top: 58px;
      width: 100%;
      .harvest-head {
        display: block;
        width: 254px;
        height: 68px;
        margin: 0 0 14px 78px;
      }
      .harvest-block {
        .harvest-item:not(:last-child) {
          margin-bottom: 60px;
        }
        width: 100%;
        background: fade(#FCC936, 20%);
        padding: 40px 0 48px 90px;
        box-sizing: border-box;
        .harvest-item {
          .harvest-title {
            color: #FF7508;
            font-size: 26px;
            font-weight: @font-weight-bold;
          }
          .harvest-content {
            font-size: 26px;
          }
        }
      }
    }
    .assess {
      width: 664px;
      margin-top: 58px;
      .assess-head {
        width: 316px;
        height: 66px;
        margin-left: 34px;
      }
    }
  }
  .contact-us {
    position: fixed;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 110px;
    line-height: 110px;
    font-size: 28px;
    background: #fcc936;
    color: @color-white;
    display: flex;
    text-align: center;
    a {
      color: @color-white;
      width: 100%;
      height: 110px;
      display: block;
    }
    .tel {
      flex: 1;
      position: relative;
      &:after {
        position: absolute;
        right: 0;
        top: 15px;
        width: 1px;
        height: 80px;
        content: '';
        background-color: fade(@color-white, 50%);
      }
    }
    .qr-code {
      flex: 1;
    }
  }
</style>
